// Scene palette from PRD section 14.4 and the three.js mockup (scene.js).
// The HUD colours live in src/styles/tokens/colors.css, copied from the design system.

export const C = {
  sky: '#1f66f2',
  sea: '#2a7bff',
  seaDeep: '#1a5ae6',
  column: '#b9d6ff',
  foam: '#ffffff',
  grass: ['#c9c656', '#b7b446'],
  skirt: '#a9a03a',
  /** The rim around an interior's grid: grass a shade apart from the cells, so it never reads as one. */
  rim: '#c4c163',
  forest: ['#c2bb4a', '#b4ad40'],
  sand: ['#f6df92', '#efd47f'],
  sandLayer: '#f6dca2',
  rock: ['#d3cbbb', '#c6bdac'],
  thermal: ['#e2b57e', '#d8aa72'],
  riverbed: '#e9d29a',
  water: '#3d8cff',
  autumn: ['#f7931e', '#ffa62b', '#f5a01f', '#ffb43a'],
  green: ['#6fae3e', '#7fbf45'],
  trunk: '#e9e2d6',
  wall: '#f3ede2',
  timber: '#8a4b2c',
  roofBlue: '#2f7fe8',
  roofOrange: '#f39a3d',
  stone: '#9a968e',
  metal: '#8d97a5',
  glass: '#9fd4ff',
  dark: '#2c3445',
  window: '#3a5fa8',
  belt: '#4b505c',
  beltCurb: '#7a808c',
  beltArrow: '#e9edf3',
  iron: '#9aa7b6',
  portIn: '#2f8cff',
  portOut: '#ff8a2a',
  ore: '#a0563f',
  oreCopper: '#e58a3b',
  boulder: '#a39d93',
  pebble: '#8f8c86',
  tuft: '#e2404f',
  cloud: '#ffffff',
  sparkle: '#9cc8ff',
  sun: '#fff1d6',
  skyLight: '#dfeaff',
  groundLight: '#b89a5a',
} as const;

/** Skirt (tufted edge) colour per terrain when it differs from the grass edge. */
export const SKIRT: Partial<Record<string, string>> = {
  a: '#e2c67c',
  h: '#a9a294',
  c: '#a9a294',
  m: '#a9a294',
  t: '#c89a63',
};
